import { createFileRoute, Link } from '@tanstack/react-router';
import { XIcon } from 'lucide-react';

export const Route = createFileRoute('/_authenticated/_global/pricing/canceled')({
  component: CanceledComponent,
});

function CanceledComponent() {
  return (
    <div className="bg-background flex flex-1 flex-col items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-md text-center">
        <div className="inline-flex size-12 items-center justify-center rounded-full bg-red-500">
          <XIcon className="text-white" />
        </div>
        <h1 className="text-foreground mt-4 text-3xl font-bold tracking-tight sm:text-4xl">
          Payment Canceled
        </h1>
        <p className="text-muted-foreground mt-4">
          Your payment was canceled. If you have any questions, please contact us.
        </p>
        <div className="mt-6">
          <Link
            to="/projects"
            className="bg-primary text-primary-foreground hover:bg-primary/90 focus:ring-primary inline-flex items-center rounded-md px-4 py-2 text-sm font-medium shadow-xs transition-colors focus:ring-2 focus:ring-offset-2 focus:outline-hidden"
          >
            Go to Projects
          </Link>
        </div>
      </div>
    </div>
  );
}
